import React, { useMemo, useRef, useState } from "react";
import clsx from "classnames";
import PropTypes from "prop-types";
import Popover from "@material-ui/core/Popover";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/styles";

import KeyboardRightIcon from "../icons/KeyboardRight";

import MenuItem from "./MenuItem";

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    pointerEvents: "all",
  },
  optionSelectHover: {
    backgroundColor: "#eeeeee",
  },
}));

const NestedMenuItem = ({
  maxHeight,
  parentMenuOpen,
  rightIcon,
  label,
  children,
  highlightColor,
  ...props
}) => {
  const subMenuItemRef = useRef();
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const classes = useStyles();

  const {
    handleClose,
    handleItemClick,
    handleMouseEnter,
    handleMouseLeave,
  } = useMemo(
    () => ({
      handleClose: () => setSubMenuOpen(false),
      handleItemClick: () => setSubMenuOpen((value) => !value),
      handleMouseEnter: () => setSubMenuOpen(true),
      handleMouseLeave: () => setSubMenuOpen(false),
    }),
    []
  );

  const open = subMenuOpen && parentMenuOpen;

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleItemClick}
    >
      <MenuItem
        itemRef={subMenuItemRef}
        rightIcon={rightIcon}
        classes={{
          root: clsx({
            [classes.optionSelectHover]: open,
          }),
        }}
      >
        {label}
      </MenuItem>
      <Popover
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        {...props}
        hideBackdrop
        open={open}
        anchorEl={subMenuItemRef.current}
        style={{
          maxHeight: maxHeight,
        }}
        className={classes.popover}
        PaperProps={{
          className: classes.paper,
        }}
        onClose={handleClose}
      >
        {children}
      </Popover>
    </Box>
  );
};

NestedMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  parentMenuOpen: PropTypes.bool.isRequired,
  rightIcon: PropTypes.object,
};

NestedMenuItem.defaultProps = {
  maxHeight: 300,
  rightIcon: <KeyboardRightIcon />,
};

export default NestedMenuItem;
